import { TPromoHeroInfoBlock } from '@/shared/types/deprecated-types'

type CardBenefitsProps = {
	title: string
	description: string
	imgSrc: string
}

export const heroInfoData: TPromoHeroInfoBlock = {
	imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/gift-card/hero.png`,
	title: `Подарочные карты iPort`,
	subtitle: `Не знаете, что подарить? Порадуйте близкого человека подарочной картой. Хороший вариант для тех, кто предпочитает дарить то, что действительно нужно.`
}

export const cardBenefits: CardBenefitsProps[] = [
	{
		title: `Универсальность`,
		description: `Выручит в любой ситуации — карту можно подарить другу, любимому человеку или коллеге.`,
		imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/gift-card/people-icon.png`
	},
	{
		title: `Доступность`,
		description: `Номинал карты может быть любым — от 1 000 ₽. Вы сами определяете сумму, которая будет на карте. `,
		imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/gift-card/wallet-icon.png`
	},
	{
		title: `Свобода выбора`,
		description: `Карта действует на весь ассортимент магазина, можно выбрать всё самое нужное.`,
		imgSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/gift-card/phone-icon.png`
	}
]

export const faqItems = [
	{
		question: `Что будет, если выбранные товары стоят меньше, чем номинал карты?`,
		answer: `При покупке с вашего сертификата спишется стоимость текущего заказа. Остаток суммы будет доступен в течение всего срока действия подарочной карты. Для следующих покупок потребуется PIN-код, который придет на номер телефона, привязанный к подарочной карте.`
	},
	{
		question: `Как использовать карту?`,
		answer: `Карту можно использовать в любом розничном магазине iPort для единовременной покупки на сумму номинала карты.`
	},
	{
		question: `Могу ли я доплатить, если стоимость товара больше, чем сумма на карте?`,
		answer: `При покупке на сумму, превышающую номинал карты, возможна доплата наличными или банковской картой.`
	},
	{
		question: `Каков срок действия подарочной карты?`,
		answer: `Срок действия подарочной карты — один год с момента приобретения карты. В случае утраты карта не восстанавливается.`
	},
	{
		question: `Когда активируется карта?`,
		answer: `Карта активируется в момент покупки.`
	},
	{
		question: `Можно ли обменять подарочную карту на деньги?`,
		answer: `Нет. Подарочную карту нельзя обменять или вернуть.`
	}
]
